// extracted by mini-css-extract-plugin
module.exports = {"item":"_15_KiQLb0fWiZyhmRvmh8r"};